const chartSkillsLabels = {
    "fr": [
         ["COMPRENDRE", "SON ORGANISATION"],
         ["COMPRENDRE LES", "BESOINS D'AUTRUI"],
         ["RÉSOUDRE UN", "PROBLÈME COMPLEXE"],
         ["ESPRIT CRITIQUE"],
         ["CRÉER DES SOLUTIONS", "INNOVANTES"],
         ["CONSTRUIRE UNE VISION", "PERSONNELLE POUR", "SON ACTIVITÉ"],
         ["IDENTIFIER DES", "PERSONNES RESSOURCES"],
         ["COOPÉRER"],
         ["SE CONNAÎTRE "],
         ["PRENDRE DES RISQUES"],
         ["S’ENGAGER DURABLEMENT", "POUR L’ENTREPRISE"],
         ["GÉRER SON STRESS EN",  "SITUATION AMBIGUË"],
         ["PROMOUVOIR"],
         ["MOTIVER UN COLLECTIF"],
         ["CONTRIBUER À UN", "TRAVAIL COLLECTIF"],
         ["ORGANISER LE TRAVAIL", "D'UN COLLECTIF"],
         ["ORIENTER LE TRAVAIL", "D'UN COLLECTIF"]
    ],
    "en": [
         ["UNDERSTAND", "AN ORGANIZATION"],
         ["UNDERSTAND THE", "NEEDS OF OTHERS"],
         ["SOLVE A", "COMPLEX PROBLEM"],
         ["CRITICAL THINKING"],
         ["CREATE INNOVATIVE", "SOLUTIONS"],
         ["BUILD A", "PERSONAL VISION", "FOR ACTIVITY"],
         ["FIND RESOURCE", "PEOPLE"],
         ["COOPERATE"],
         ["SELF AWARENESS"],
         ["RISK-TAKING"],
         ["SUSTAINABLE", "INVOLVEMENT"],
         ["MANAGE STRESS IN AN",  "AMBIGUOUS SITUATION"],
         ["PROMOTE"],
         ["MOTIVATE A GROUP"],
         ["CONTRIBUTE TO", "GROUP TASKS"],
         ["ORGANIZE", "A GROUP"],
         ["LEAD A", "GROUP"]
    ]
}

export default chartSkillsLabels